/**
 * Centralized Border Radius Tokens for Autobet
 * Defines consistent rounding values across all components, cards, inputs, and dialogs.
 */

export const borderRadius = {
  none: 0,
  xs: 4,         // 4px - small tags, badges, scrollbar
  sm: 6,         // 6px - small buttons, chips, tooltips
  md: 8,         // 8px - standard buttons, inputs, text fields, icons
  default: 10,   // 10px - standard project inputs
  lg: 10,        // 10px - menus, dropdowns, sub-containers, large buttons
  xl: 12,        // 12px - user profile chips, medium containers
  card: 14,      // 14px - dashboard cards, containers
  dialog: 14,    // 14px - modals, dialogs
  banner: 14,    // 14px - notice banners
  ribbon: 14,    // 14px - dark stats ribbons
  xxl: 16,       // 16px - large modals, hero cards, connection panel
  surface: 20,   // 20px - outer panels, auth cards
  pill: 9999,    // fully rounded pill
  circle: "50%", // circular avatar/badge
};

/**
 * String format with 'px' suffix for direct CSS / styled-component / sx usage
 */
export const borderRadiusPx = {
  none: "0px",
  xs: `${borderRadius.xs}px`,
  sm: `${borderRadius.sm}px`,
  md: `${borderRadius.md}px`,
  default: `${borderRadius.default}px`,
  lg: `${borderRadius.lg}px`,
  xl: `${borderRadius.xl}px`,
  card: `${borderRadius.card}px`,
  dialog: `${borderRadius.dialog}px`,
  banner: `${borderRadius.banner}px`,
  ribbon: `${borderRadius.ribbon}px`,
  xxl: `${borderRadius.xxl}px`,
  surface: `${borderRadius.surface}px`,
  pill: `${borderRadius.pill}px`,
  circle: "50%",
};

export default borderRadius;
